/**
 * A QR matrix as one SVG path.
 *
 * Its own module rather than a second export beside `QrCode`, so that component
 * file keeps fast refresh — and so this can be tested for the one thing that
 * matters without rendering anything.
 */

/**
 * `M x y h1 v1 h-1 Z` per dark module, concatenated.
 *
 * ONE path rather than one `<rect>` per module: the encoder's own SVG output is
 * about 52 kB of markup for a version-7 code, and this is roughly 4 kB. It is
 * also a real DOM node instead of `dangerouslySetInnerHTML` — the input is
 * derived from a server response, and there is no version of "inject untrusted
 * markup" worth reaching for to draw a square.
 */
export function pathFor(matrix: readonly (readonly boolean[])[]): string {
  const parts: string[] = [];

  for (let y = 0; y < matrix.length; y++) {
    const row = matrix[y] ?? [];
    for (let x = 0; x < row.length; x++) {
      if (row[x] === true) parts.push(`M${x} ${y}h1v1h-1Z`);
    }
  }

  return parts.join('');
}
